import type { UserInstrumentClassificationDto } from "@eu.mdotm.api/sphere";
import { type RwAtom, atom, atomWithCompare } from "@mdotm/shadcn/legacy/reactivity";
import type { Map } from "immutable";

export const userClassificationsMap$: RwAtom<Map<string, UserInstrumentClassificationDto> | null> = atomWithCompare<Map<
	string,
	UserInstrumentClassificationDto
> | null>(null);

export const userClassifications$ = atom((get) => get(userClassificationsMap$)?.valueSeq().toArray() ?? []);
